__turbopack_context__.v({
  "actionsPlacementBottom": "Banner-module-scss-module__uLUTpG__actionsPlacementBottom",
  "actionsPlacementRight": "Banner-module-scss-module__uLUTpG__actionsPlacementRight",
  "floating": "Banner-module-scss-module__uLUTpG__floating",
  "items": "Banner-module-scss-module__uLUTpG__items",
});
